import React from "react";
import { useIntl } from "react-intl";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useNavigate } from "react-router-dom";
import { Link } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { TwoRow } from "../../core/layouts";
import PlanAuditContainer from "../../containers/PlanAuditContainer";

const PlanAuditViewStyle = {
  wrapperStyle: {
    backgroundColor: variables.grey5,
    padding: variables.paddingMedium,
    paddingTop: variables.paddingSmallLG,
  },
  bottomSectionStyle: {
    backgroundColor: variables.bodyBg,
    border: `1px solid ${variables.grey4}`,
    overflow: "auto",
    height: `calc(100vh - 11.5rem)`,
  },
  topSectionStyle: {
    paddingBottom: `${variables.paddingMedium}`,
  },
  backArrow: {
    width: variables.iconWidthLarge,
    height: variables.iconHeightLarge,
    marginRight: variables.marginMediumSmall,
  },
};

export default function PlanAuditView() {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <TwoRow
      style={PlanAuditViewStyle.wrapperStyle}
      topSectionStyle={PlanAuditViewStyle.topSectionStyle}
      topSection={
        <Link
          onClick={(e) => {
            e.preventDefault();
            navigate(-1);
          }}
          type="backNavigation"
          href="#"
          iconSrc={"/icons/arrow_back.svg"}
          labelText={getLocalizedMessage(intl, "planAudit.heading.planAudit")}
        />
      }
      bottomSectionStyle={PlanAuditViewStyle.bottomSectionStyle}
      bottomSection={<PlanAuditContainer />}
    />
  );
}
